<template>
  <v-layout>
    <div class="page-banner banner-social">
      <div class="page-banner-mask" />
      <div class="banner-inner">
        <h1><span class="icon-global" />Social Media</h1>
        <p>Multiple platforms working together for you.</p>
      </div>
    </div>
    <el-container class="lower-shadow intro-section">
      <el-main class="site-inner">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            class="article-bottom-margin">
            <h2>Share Your Message</h2>
            <p>Today, it can be confusing trying to navigate the seas of social media.  Some people have whole staffs for their social sites and treat them as their own entity.  They put so much time and effort into these sites that they can detract from their own website in views and business.  Social Media sites are designed for sharing a message, and should not substitute your main website.  That's not to say you shouldn’t put a little effort into these sites, just make sure you're not loosing out on site hits because of them.</p>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <el-container class="sunken-container marketing lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div
            slot="header"
            class="sunken-header">
            <h2><span class="icon-megaphone"/>Marketing</h2>
          </div>
          <div class="sunken-body">
            <p>New to social media, or just not sure why your post seems to flounder after the first few minutes?  Let us help you get a pattern of success with your post and bring in likes and followers, all while helping your business grow.</p>
            <service-section>
              <h3 slot="header">Our Social Marketing Services:</h3>
              <span class="one-col-xs two-col-sm three-col-md">
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-strategy" />Strategy
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Let us help you put a strategy together to make sure your message is clear and any ads tied to your post help direct potential customers to the information they need and a way to get in touch with you.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-calendar" />Schedule
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>We work with you to get a rhythm to your release of new content, making sure your audience knows when something new is released, keeping your brand spreading, and bringing in new customers with new content.</p>
                  </span>
                </service-article>
              </span>
            </service-section>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <div class="shadow-bar lower-shadow" />

    <el-container class="sunken-container content lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div
            slot="header"
            class="sunken-header">
            <h2><span class="icon-document"/>Content</h2>
          </div>
          <div class="sunken-body">
            <p>We work with you to make sure your content present a clear message and your post look professional.  We can work with an existing team or supplement your own business by providing our own services creating content and pushing it live after your approval.</p>
            <service-section>
              <h3 slot="header">Our Social Content Services:</h3>
              <span class="one-col-xs two-col-sm three-col-md">

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-paintbrush" />Creative
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Let us help you be creative with your social media content.  This includes text, images, and video.  We help you make sure your content is eye-catching to help bring more clicks without being click-bait.</p>
                  </span>
                </service-article>

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-clock" />Consistent
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>When your working with multiple social media platforms you have different constrictions on what you can post or how much you can say in a post.  We work to make sure that each post is on point and relay the same message to your audience.</p>
                  </span>
                </service-article>
              </span>
            </service-section>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </v-layout>
</template>

<script>
import ServiceSection from '@/layouts/sections/services.vue';
import ServiceArticle from '@/layouts/articles/service.vue';

/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import VLayout from '@/layouts/Default.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'HomeIndex',
  /**
   * The components that the page can use.
   */
  components: {
    VLayout,
    ServiceSection,
    ServiceArticle,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$ga.page(this.$router);
  },
  methods: {
    collapseToggle(e) {
      let parent = e.target.parentElement;
      if (parent.nodeName === 'H4') {
        parent = e.target.parentElement.parentElement;
      }
      const grandParent = parent.parentElement;
      const main = parent.nextSibling;
      if (main.style.maxHeight) {
        main.style.maxHeight = null;
        grandParent.classList.remove('collapse-active');
      } else {
        main.style.maxHeight = `${main.scrollHeight}px`;
        grandParent.classList.add('collapse-active');
      }
    },
  },
};
</script>
